/**
*@title 게시판
*@date 2022-02-07
*@author 홍수희
*@desc
*@etc(change)
*/

import React,{useState,useEffect} from 'react';
import axios from 'axios';

import { useTranslation } from "react-i18next";

import PostContents from './PostContents.js';
import Pagination from './Pagination.js';
import PostModal from './PostModal.js';


const Board = () => {
    const { t } = useTranslation();

    const [tabNumber,setTabNumber] = useState('1'); //선택한 탭 번호
    const [tabName,setTabName] = useState('공지사항'); //선택한 탭 이름
    const [tabToggle,setTabToggle] = useState(false); //탭 토글 데이터 없으면 출력 안되게 함
    const [list,setList] = useState(null); //각 게시판 게시글 리스트
    const [popupToggle,setPopupToggle] = useState(false); //공지사항, 보도자료 팝업
    const [post,setPost] = useState(null); //게시글 한개 클릭시 팝업창에 넘겨줄 게시글 데이터 (1개)

    //pagination
    const page = 6;
    const [curPage,setCurPage] = useState(1);
    const idxOfLast = curPage * page;
    const idxOfFirst = idxOfLast - page;
    const [currentList,setCurrentList] = useState(null);

    useEffect(()=>{
        const parm = setTableName(1);
        // 아래 변수를 고쳐 주세요.
        // {} 하나가 게시글 하나, 변수는 똑같이 통일해야합니다. 내용만 변경.
        const res = [
            {no: 1, title: "모바일 페이지 안내", writer: "관리자", created_at: "2022-07-24", contents: "현재 웹사이트는 데스크탑 버전에 최적화 되어있습니다.\n게놈바이오엑스포 웹사이트의 모바일 버전은 서비스 준비 중이오니, 양해부탁드립니다. \n\n감사합니다.", eng_contents:"Our websites are optimized to Desktop browser."}
        ]
        setTabToggle(true);
        setList(res);
        setCurrentList(res.slice(idxOfFirst,idxOfLast));}, [tabNumber])

    useEffect(()=>{
        if(list != null && list.length > 0){
            setCurrentList(list.slice(idxOfFirst,idxOfLast));
        }
    },[curPage])


    function setTableName(num){
        var tableName = ''
        if(num === '2'){
            setTabName('보도자료')
            tableName = 'presses';
        }else if(num === '3'){
            setTabName('갤러리')
            tableName = 'gallery';
        }else if(num === '4'){
            setTabName('문의사항')
            tableName = 'inquiries';
        }else{
            setTabName('공지사항')
            tableName = 'notices';
        }
        return tableName;
    }
    //탭버튼 클릭
    function tabClick(num){
        setTabNumber(num);
    }
    //하단 숫자 클릭
    function numClick(page){
        setCurPage(page);
    }
    //공지사항,보도자료 팝업
    function closePopup(){
        setPopupToggle(false);

    }
    function openPopup(postData){
        setPopupToggle(true);
        setPost(postData);


    }
    
    return(
        <div className="mid-section-wrap-02">
            {popupToggle && <PostModal tabName = {tabName} closePopup={closePopup} post={post}/> }
            <div className="cnt-section-wrap-02">
                <div className="mid-section-cnt">
                    <div className="sect-08-tit-01 sect-tit" href="#section-1">{t("header_info_notice")}</div>
                    <div id="tabs" className="tabs">
                        <div className="tab-content">
                            <PostContents tabName={tabName} list={currentList} openPopup={openPopup}/>
                        </div>
                        {(list != null && list.length > 0) && <Pagination total={list.length} numClick={numClick}/>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Board;